import React from "react";
import Link from "../Link";
import homeLogo from "../../img/HomeLogo.png";
import "./DashboardButtons.css";

function DashboardButtons(props) {
  const {className} = props

  return (
    <Link href='/' className="rectangle-5867">
        <img className="dashboard-logo" src={homeLogo} />
        <div className={`dashboard ${className || "nunito-bold-black-16px"}`}>Dashboard</div>
    </Link>
  );
}

export default DashboardButtons;
